// | Module AUTOGENERATED by translations
// See translations/README.md
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
const t = /* #__PURE__ */ Restaumatic$dI18n$dTranslationKeys.unsafeMakeTranslationKeysProxy("_core_types_sites");
export {t};
